import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthState } from '../../store/authInfo/auth-state';
import { Select, Store } from '@ngxs/store';
import { DeleteAuthentication, SetAuthentication } from '../../store/authInfo/auth-actions';
import { environment } from '../../environments/environment';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ACLService, ACLType } from '@delon/acl';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements CanActivate {

  @Select(AuthState) appState$: Observable<any> | undefined;
  authentication: any = null;
  constructor(
    // public rxStompService: RxStompService,
    public httpClient: HttpClient,
    public store: Store,
    public router: Router,
    public message: NzMessageService,
    public aclService: ACLService,
  ) {
    // 订阅认证状态变化通知
    if(this.appState$ != undefined){
      this.appState$.subscribe((authentication: any) => {
        this.authentication = authentication;
      });
    }
  }
  /**
   *
   * @param route 路由
   * @param state 路由状态
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // 判断是否登录成功
    if (this.isLogin()) {
      if(this.authentication != null){
          if (this.authentication.userInfo.perms.menuPermissions.length > 0) {
            // 设置权限和角色到ACLService，用于界面的权限判断，显示或隐藏界面中的标签
            const roles: any[] = [];
            this.authentication.userInfo.roles.forEach((role: any) => {
              roles.push(role.roleKey);
            });
            let perms: any[] = [];
            this.authentication.userInfo.perms.functionPermissions.forEach((perm: any) => {
              perms.push(perm.perms);
            });
            perms = this.getPermsFromTree(this.authentication.userInfo.perms.menuPermissions, perms);
            const aclType: ACLType = { ability: perms, role: roles, mode: 'allOf' };
            this.aclService.setFull(false);
            this.aclService.set(aclType);
          }
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      }else{
        this.router.navigate(['/login']);
        return false;
      }
      
  }
  // 登录
  login(userName: string, password: string): Observable<any> {
    const url = 'plan/api/system/login';
    const params = new FormData();
    params.append('userName', userName);
    params.append('password', password);
    return new Observable((observer) => {
      this.httpClient.post(url, params).subscribe((ret: any) => {
        if (ret.code === 200) {
          this.store.dispatch(new SetAuthentication(ret.data)).subscribe((retStore) => {
            observer.next(retStore);
          });
        } else {
          observer.error(ret.data);
        }
      });
    });
  }

  // 登出
  logout(): Observable<any> {
    const url = 'plan/api/system/logout';
    return new Observable((observer) => {
      this.httpClient.post(url, null).subscribe((ret: any) => {
        if (ret.code === 200) {
          this.store.dispatch(new DeleteAuthentication()).subscribe((retStore) => {
            observer.next(retStore);
          });
        } else {
          observer.error();
        }
      });
    });
  }

  signOn(token: string): Promise<any> {
    const url = 'plan/api/system/sign_on';
    const params = new FormData();
    params.append('jwtToken', token);
    return new Promise((resolve, reject) => {
      this.httpClient.post(url, params).subscribe((ret: any) => {
        if (ret.code === 200) {
          this.store.dispatch(new SetAuthentication(ret.data)).subscribe((retStore: any) => {
            resolve(retStore);
          });
        } else {
          resolve(null);
        }
      });
    });

  }
  signOnByCallerId(callerId: string, qywxUserName?: string, qywxPhoneNumber?: string): Promise<any> {
    const url = 'plan/api/system/caller_Login';
    const params = new FormData();
    params.append('callerId', callerId);
    return new Promise((resolve, reject) => {
      this.httpClient.post(url, params).subscribe((ret: any) => {
        if (ret.code === 200) {
          ret.data.userInfo.callId = callerId;
          if (qywxPhoneNumber != null && qywxPhoneNumber !== undefined){
            ret.data.userInfo.qywxUserName = qywxUserName;
          }
          if (qywxPhoneNumber != null && qywxPhoneNumber !== undefined){
            ret.data.userInfo.qywxPhoneNumber = qywxPhoneNumber;
          }
          this.store.dispatch(new SetAuthentication(ret.data)).subscribe((retStore: any) => {
            resolve(retStore);
          });
        } else {
          resolve(null);
        }
      });
    });

  }

  // 是否已登陆
  isLogin() {
    return this.authentication != null && this.authentication.session != null &&
      this.authentication.session.id != null && this.authentication.session.id !== environment.touristToken;
  }

  // 获取游客ID，用于非登录条件下移动端访问
  getTouristId() {
    if (this.authentication != null) {
      if (this.authentication.tourist != null && this.authentication.tourist !== undefined) {
        return this.authentication.tourist.id;
      } else {
        return this.authentication.userInfo.callId;
      }
    }
    return null;
  }
  /**
   * 获取游客信息，非登录条件下移动端访问
   */
  getTouristInfo() {
    if (this.authentication != null && this.authentication.tourist != null) {
      return this.authentication.tourist;
    }
    return null;
  }
  // 获取当前用户信息
  public getCurrentUserInfo() {
    if (this.authentication == null) {
      return null;
    }
    return this.authentication.userInfo;
  }

  // 获取当前用户角色
  getCurrentRoles() {
    if (this.authentication == null || this.authentication.authorizationInfo == null) {
      return null;
    }
    return this.authentication.authorizationInfo.roles;
  }

  // 获取当前用户权限
  getCurrentPermissions() {
    if (this.authentication == null || this.authentication.authorizationInfo == null) {
      return null;
    }
    return this.authentication.authorizationInfo.perms;
  }
  // 获取当前用户字典
  getDictionaryDatas() {
    if (this.authentication == null || this.authentication.authorizationInfo == null) {
      return null;
    }
    return this.authentication.authorizationInfo.dictionaryDatas;
  }
  // 获取当前系统设置
  // getCurrentSysConfigs() {
  //   if (this.authentication == null) {
  //     return null;
  //   }
  //   return this.authentication.sysconfig;
  // }
  getPermsFromTree(treeNode: [], perms: any) {
    treeNode.forEach((childNode: any) => {
      perms.push(childNode.perms);
      if (childNode.children != null && childNode.children.length > 0) {
        this.getPermsFromTree(childNode.children, perms);
      }
    });
    return perms;
  }
  getStatusByDictTypeAndDictValue(dictType: string, dictValue: string){
    const dictionaryDatas = this.getDictionaryDatas();
    if (dictionaryDatas == null){
      return false;
    }
    let ret = false;
    if (dictionaryDatas.length > 0 ){
      const ls = dictionaryDatas.filter((dict: any) => {
        return dict.dictValue === dictValue && dict.dictType === dictType;
      });
      if (ls.length > 0){
        if (ls[0].status === '0'){ // 1表示停用 0 表示启用
          ret = true;
        }else{
          ret = false;
        }
      }else{
        ret = false;
      }
    }else{
      ret = false;
    }
    return ret;
  }
}
